import T from './types';

export function setCustomWrapperStyles(styles) {
  return {
    type: T.SET_CUSTOM_WRAPPER_STYLES,
    styles,
  };
}
